import { createContext, useContext } from 'react';

interface DrawerRecordContextValue {
  record: Record<string, unknown> | null;
}

export const DrawerRecordContext = createContext<DrawerRecordContextValue>({
  record: null,
});

/**
 * 获取 Drawer 中的行记录数据
 * 在 Drawer 内的子组件中使用
 */
export function useDrawerRecord() {
  return useContext(DrawerRecordContext);
}